import {
  FINISH_CHECK_DEPOSIT,
  REFRESH_AFTER_INSTANT_DEPOSIT,
  RELOAD_COMBINED_PROVIDER
} from '#client/constants/eventName';

export const dispatchRefetchCheckDeposit = () => {
  const event = new Event(FINISH_CHECK_DEPOSIT);
  window.dispatchEvent(event);
};

export const dispatchRefreshDataAfterInstantDeposit = () => {
  const event = new Event(REFRESH_AFTER_INSTANT_DEPOSIT);
  window.dispatchEvent(event);
};

export const dispatchReloadCombinedProvider = () => {
  const event = new Event(RELOAD_COMBINED_PROVIDER);
  window.dispatchEvent(event);
};
